import { render, staticRenderFns } from "./qyxxbg2.vue?vue&type=template&id=26ea8baf&scoped=true&"
import script from "./qyxxbg2.vue?vue&type=script&lang=js&"
export * from "./qyxxbg2.vue?vue&type=script&lang=js&"
import style0 from "./qyxxbg2.vue?vue&type=style&index=0&id=26ea8baf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ea8baf",
  null
  
)

export default component.exports